export default "__VITE_PUBLIC_ASSET__aece6c4d__"